module.exports = __webpack_public_path__ + "img/uj_08.9efc21d3.jpg";